import { InitialStateType } from "../context/context";
import { payloadTypes } from "../context/reducer";
import { Actions } from "../context/types";
import { initialState } from "../context/context";
import {
  BUTTON,
  EMPTY_STRING,
  INPUT,
  SELECT,
  TEXTAREA,
  TicketStatus,
} from "./constants";
import {
  optionsType,
  responseType,
  TicketDetailsType,
  YesNoOptionsType,
} from "./formTypes";
import { Keys } from "./Enum.keys";
import { JunctionStatus, PriorityEnum, TagNames, TimeZone } from "./Enum.types";
import dayjs from "dayjs";
import Xls from "../images/Excel.svg";
import Pdf from "../images/DownloadPdf.svg";
import Doc from "../images/WordDocument.svg";
import Image from "../images/DownloadImage.svg";
import Audio from "../images/DownloadAudio.svg";
import Modal from "react-modal";
import { CustomModalProps } from "./types";

import { DropResult } from "react-beautiful-dnd";

import COMMISSIONED from "../images/dashboard/junctionStatusCount/Commissioned.svg";
import DECOMMISSIONED from "../images/dashboard/junctionStatusCount/DeCommissioned.svg";
import INSTALLED from "../images/dashboard/junctionStatusCount/Installed.svg";
import PLANNED from "../images/dashboard/junctionStatusCount/Planned.svg";
import SHIFTING from "../images/dashboard/junctionStatusCount/Shifting.svg";
import WORK_IN_PROGRESS from "../images/dashboard/junctionStatusCount/InProgress.svg";
import NOT_WORKING from "../images/dashboard/junctionStatusCount/Not Working.svg";

export const toggleFullSceen = (): void => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
};

export const clearGlobalStates = (
  dispatch: React.Dispatch<Actions>,
  state: InitialStateType
) => {
  dispatch({
    type: payloadTypes.RESET,
    payload: {
      resetState: {
        ...initialState,
        claims: state.claims,
        user: state.user,
      },
    },
  });
};

export const handleMUISelectEvent = (event: any) => {
  event.preventDefault();
  const form = event.target.form;

  const notDisabledElements: any[] = Object.values(form.elements).filter(
    (x: any) =>
      x.disabled !== true &&
      (x.tagName === INPUT ||
        x.tagName === SELECT ||
        x.tagName === TEXTAREA ||
        (x.tagName === BUTTON && !x.classList.contains("MuiButtonBase-root")))
  );
  const customIndex = notDisabledElements.indexOf(
    notDisabledElements.find((elem) => elem === event.target)
  );

  notDisabledElements[customIndex + 1].focus();
};

export const getModifiedScrollHeight = (scrollHeight: number) => {
  const percentage = 75;
  const hundred = 100;
  return percentage * (scrollHeight / hundred);
};

export const handleFormEvent = (event: any) => {
  if (event.keyCode === 13) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    const elementNotDisabled = Object.entries(form.elements).filter(
      (x: any) =>
        x[1].disabled !== true &&
        (x[1].tagName === INPUT ||
          x[1].tagName === SELECT ||
          x[1].tagName === TEXTAREA ||
          x[1].tagName === BUTTON)
    );
    if (form.elements[index + 1].disabled) {
      const nextNotDisabledElement = elementNotDisabled.find(
        (x: any) => x[0] > index + 1
      );
      form.elements[
        nextNotDisabledElement ? nextNotDisabledElement[0] : 0
      ].focus();
    }
    if (form.elements[index + 1].name === "search") {
      form.elements[index + 2].focus();
    } else form.elements[index + 1].focus();
    event.preventDefault();
  }
};

export const hanldeTextAreaFormEvent = (
  e: React.KeyboardEvent<Element>,
  setFormData: (
    value: React.SetStateAction<{ [key: string]: string | number }>
  ) => void
) => {
  if (e.shiftKey && e.key === Keys.ENTER) {
    const { name, value } = e.target as HTMLInputElement;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  } else if (e.key === Keys.ENTER) {
    handleFormEvent(e);
  }
};

export const removeMoreSpace = (string: string | number) => {
  let stringValue = "";
  if (string) stringValue = string.toString();
  return stringValue?.replace(/ +/g, " ").trim();
};

export const addCountryCode = (mobileNumber: string) => {
  return mobileNumber
    ? mobileNumber.startsWith("+")
      ? mobileNumber
      : `+${mobileNumber}`
    : "";
};

export const toStandardCase = (string: string) => {
  return string?.replaceAll(
    /\S*/g,
    (word) => `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`
  );
};

export const isOptionEqualToValue = (
  optionData: responseType | optionsType | YesNoOptionsType,
  valueData: responseType | optionsType | YesNoOptionsType | null
) => {
  if (valueData) {
    return optionData.value === valueData.value;
  } else {
    return false;
  }
};

export const RefsByTagName = (
  ref: React.RefObject<HTMLSelectElement | HTMLInputElement | null>
) => {
  return ref?.current?.getElementsByTagName(
    TagNames.INPUT
  )[0] as HTMLInputElement;
};

export const toInputStandardDate = (day: string) => {
  return day ? dayjs(day).format("YYYY-MM-DD") : EMPTY_STRING;
};

export const toIsoDate = (date: string) => dayjs(date).format();
export const convertToDateObject_MMDDYYYYFormat = (dateString: string) => {
  const delimiter = dateString.includes("/") ? "/" : "-";
  const [dayStr, month, year] = dateString.split(delimiter).map(Number);
  const day = dayStr < 10 ? `0${dayStr}` : dayStr;
  return new Date(`${month}/${day}/${year}`).toString();
};

export const toStandardDate = (date: string) => {
  const parsedDate = dayjs(date);

  if (!parsedDate.isValid()) {
    return "Invalid Date";
  }
  return parsedDate.format("DD-MM-YYYY");
};
export const getFileIcon = (filename: string) => {
  const extension = filename.split(".").pop()?.toLowerCase();
  switch (extension) {
    case "pdf":
      return `${Pdf}`;
    case "doc":
    case "docx":
      return `${Doc}`;
    case "xls":
    case "xlsx":
      return `${Xls}`;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return `${Image}`;
    case "mp3":
    case "wav":
      return `${Audio}`;
    default:
      return "";
  }
};
export const handleDownloadFiles = (filename: string, url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Set the app element (usually your root element)
Modal.setAppElement("#root"); // Replace '#root' with your app's root element ID

export const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onRequestClose,
  contentComponent,
  style,
}) => {
  return (
    <Modal
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={style}
    >
      {contentComponent}
    </Modal>
  );
};

export const removeCompleteSpace = (val: string) => {
  return val.replaceAll(" ", "");
};
export const handleZeros = (e: string) => {
  switch (e) {
    case "1":
      return "";
    case "2":
      return "0";
    case "3":
      return "00";
    case "4":
      return "000";
    case "5":
      return "0000";
    default:
      return "";
  }
};

export const convertToTimeZone = (timeZone: TimeZone, date: string) => {
  const utcDate = new Date(date);
  return {
    timeAndDate: utcDate.toLocaleString("en-IN", {
      timeZone: timeZone,
    }),
    time: utcDate
      .toLocaleString("en-IN", {
        timeZone: timeZone,
      })
      .split(",")[1],
    date: utcDate
      .toLocaleString("en-IN", {
        timeZone: timeZone,
      })
      .split(",")[0],
  };
};

export const ticketPriorityClassName = (priority: string) => {
  switch (priority) {
    case PriorityEnum.CRITICAL:
      return "priority-critical";
    case PriorityEnum.MAJOR:
      return "priority-major";
    case PriorityEnum.MEDIUM:
      return "priority-medium";
    case PriorityEnum.LOW:
      return "priority-low";
    default:
      return "";
  }
};

export const ticketStatusClassName = (status: string) => {
  switch (status) {
    case TicketStatus.OPEN:
      return "open-ticket-status";
    case TicketStatus.RE_OPENED:
      return "re-open-ticket-status";
    case TicketStatus.RESOLVED:
      return "resolved-ticket-status";
    case TicketStatus.CLOSED:
      return "closed-ticket-status";
    case TicketStatus.ASSIGNED:
      return "assigned-ticket-status";
    case TicketStatus.EXEMPTED:
      return "exempted-ticket-status";
    default:
      return "";
  }
};
export const ticketStatusMobileClassName = (status: string) => {
  switch (status) {
    case TicketStatus.OPEN:
      return "mobile-tkt-open-status";
    case TicketStatus.RE_OPENED:
      return "mobile-tkt-reopen-status";
    case TicketStatus.RESOLVED:
      return "mobile-tkt-resolved-status";
    case TicketStatus.CLOSED:
      return "mobile-tkt-closed-status";
    case TicketStatus.ASSIGNED:
      return "mobile-tkt-assign-status";
    default:
      return "";
  }
};

export const reOrderProcess = (result: DropResult, temp: any) => {
  if (!result.destination) return;
  const { source, destination } = result;

  if (source.index === destination.index) return;

  const [movedItem] = temp.splice(source.index, 1);
  temp.splice(destination.index, 0, movedItem);
};

export const colorsInGraph = [
  "#FCD34D",
  "#FBBF24",
  "#D6BCFA",
  "#B794F4",
  "#9F7AEA",
  "#ED8936",
  "#DD6B20",
  "#FBBF24",
  "#B794F4",
  "#D6BCFA",
  "#9F7AEA",
  "#D9F99D",
  "#BEF264",
  "#A3E635",
  "#7DD3FC",
  "#38BDF8",
  "#F5D0FE",
  "#F0ABFC",
  "#E879F9",
  "#F687B3",
  "#F687B3",
  "#ED64A6",
  "#A0AEC0",
  "#CBD5E0",
  "#718096",
  "#7DD3FC",
  "#38BDF8",
  "#BAE6FD",
  "#FDE68A",
];

export const convertEnumToLabels = (
  eNum: JunctionStatus | PriorityEnum | null
) => {
  if (eNum) return toStandardCase(eNum.split("_").join(" "));
  else return "";
};

export const junctionStatusIcons: { [key: string]: string } = {
  NOT_WORKING,
  COMMISSIONED,
  DECOMMISSIONED,
  INSTALLED,
  PLANNED,
  SHIFTING,
  WORK_IN_PROGRESS,
};

export const enum junctionStatus {
  NOT_WORKING = "NOT_WORKING",
  COMMISSIONED = "COMMISSIONED",
  INSTALLED = "INSTALLED",
  WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
  PLANNED = "PLANNED",
  SHIFTING = "SHIFTING",
  DECOMMISSIONED = "DECOMMISSIONED",
}
export const getJunctionStatusDetails = (status: junctionStatus) => {
  switch (status) {
    case junctionStatus.NOT_WORKING:
      return {
        image: NOT_WORKING,
        value: "Notworking",
        className: "",
      };
    case junctionStatus.COMMISSIONED:
      return {
        image: COMMISSIONED,
        value: "Commissioned",
        className: "",
      };
    case junctionStatus.INSTALLED:
      return {
        image: INSTALLED,
        value: "Installed",
      };
    case junctionStatus.WORK_IN_PROGRESS:
      return {
        image: WORK_IN_PROGRESS,
        value: "Work In Progress",
      };
    case junctionStatus.PLANNED:
      return {
        image: PLANNED,
        value: "Planned",
      };
    case junctionStatus.SHIFTING:
      return {
        image: SHIFTING,
        value: "Shifting",
      };
    case junctionStatus.DECOMMISSIONED:
      return {
        image: DECOMMISSIONED,
        value: "Decommissioned",
      };
    default:
      return {
        image: "",
        value: "",
      };
  }
};

export function downloadFile(file: File) {
  const url = URL.createObjectURL(file); // Create a blob URL
  const a = document.createElement("a"); // Create anchor element
  a.href = url;
  a.download = file.name; // Set filename for download
  document.body.appendChild(a);
  a.click(); // Trigger download
  document.body.removeChild(a); // Clean up
  URL.revokeObjectURL(url); // Release memory
}

export const fallbackCopy = (text: string) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;

  // Avoid scrolling to bottom
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "0";

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    document.execCommand("copy");
    alert("Text copied using fallback!");
  } catch (err) {
    console.error("Fallback copy failed", err);
  }

  document.body.removeChild(textarea);
};

export const handleCopy = (text: string) => {
  // Modern API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("Text copied to clipboard!");
      })
      .catch((err) => {
        console.error("Clipboard API failed, using fallback", err);
        fallbackCopy(text);
      });
  } else {
    // Fallback for older browsers
    fallbackCopy(text);
  }
};

export const getAging = (endDate: string, startDate: string) => {
  const presentDate = new Date(endDate);
  const ticketDate = new Date(startDate);

  const diffMs = Math.abs(ticketDate.getTime() - presentDate.getTime()); // Absolute difference in ms

  const diffSec = Math.floor(diffMs / 1000); // Total seconds
  const diffMin = Math.floor(diffSec / 60); // Total minutes
  const diffHours = Math.floor(diffMin / 60); // Total hours
  const diffDays = Math.floor(diffHours / 24); // Total days

  const remainingHours = diffHours % 24; // Hours excluding full days
  const remainingMinutes = diffMin % 60; // Minutes excluding full hours
  const remainingSeconds = diffSec % 60; // Seconds excluding full minutes

  let result = "";
  if (diffDays) result += `${diffDays} days `;
  if (remainingHours) result += `${remainingHours} hrs `;
  if (remainingMinutes) result += `${remainingMinutes} mins `;
  if (remainingSeconds) result += `${remainingSeconds} secs`;

  return result.trim(); // Remove extra spaces
};
